import { PersonaType, CrewMemberDiscipline, CrewMemberShiftType, CrewMember } from '@bechtel/types';
import { t } from '@lingui/macro';

export const AllForemanId = 'all-fm';
export const UnassignedForemanId = 'unassigned-fm';
export const AllGeneralForemanId = 'all-gf';
export const UnassignedGeneralForemanId = 'unassigned-gf';
export const AllSuperintendentId = 'all-sup';
export const UnassignedSuperintendentId = 'unassigned-sup';

export const MockAllForeman: CrewMember = {
  id: AllForemanId,
  firstName: t`All`,
  lastName: '',
  persona: PersonaType.FOREMAN,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};
// Do not delete/change, being used to build logic for all/unassigned scenarios
export const MockUnassignedForeman: CrewMember = {
  id: UnassignedForemanId,
  firstName: t`Unassigned`,
  lastName: '',
  persona: PersonaType.FOREMAN,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};
// Do not delete/change, being used to build logic for all/unassigned scenarios
export const MockAllGeneralForeman: CrewMember = {
  id: AllGeneralForemanId,
  firstName: t`All`,
  lastName: '',
  persona: PersonaType.GENERAL_FOREMAN,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};
// Do not delete/change, being used to build logic for all/unassigned scenarios
export const MockUnassignedGeneralForeman: CrewMember = {
  id: UnassignedGeneralForemanId,
  firstName: t`Unassigned`,
  lastName: '',
  persona: PersonaType.GENERAL_FOREMAN,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};

// Do not delete/change, being used to build logic for all/unassigned scenarios
export const MockUnassignedSuperintendent: CrewMember = {
  id: UnassignedSuperintendentId,
  firstName: t`Unassigned`,
  lastName: '',
  persona: PersonaType.SUPERINTENDENT,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};

// Do not delete/change, being used to build logic for all/unassigned scenarios
export const MockAllSuperintendent: CrewMember = {
  id: AllSuperintendentId,
  firstName: t`All`,
  lastName: '',
  persona: PersonaType.SUPERINTENDENT,
  discipline: CrewMemberDiscipline.NONE,
  imageUrl: '',
  shiftType: CrewMemberShiftType.DAY,
};
